import declensionByNum from 'src/utils/declensionByNum'

export const formatLpuCardRating = (rating: number) => rating.toFixed(1)

export const formatLpuCardReviewsCountText = (count: number) => (
  `${count.toLocaleString('ru-RU')} ${
    declensionByNum(count, ['отзыв', 'отзыва', 'отзывов'])
  }`
)

export const formatLpuCardAnalysesCountText = (count: number) => (
  `${count.toLocaleString('ru-RU')} ${
    declensionByNum(count, ['анализ', 'анализа', 'анализов'])
  }`
)

export const formatLpuCardBranchesCountText = (
  count: number,
  townNamePred: string,
) => (
  `${count.toLocaleString('ru-RU')} ${
    declensionByNum(count, ['филиал', 'филиала', 'филиалов'])
  } в ${townNamePred}`
)
